export default __webpack_public_path__ + "static/media/refresh.cefb8bcc.svg";